import MenuItem from '@mui/material/MenuItem';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { FieldValidationType } from '../../../../sic-lib/enums/FieldValidationType';

const useStyles = makeStyles()({
    textField: {
        minWidth: '16ch',
    },
});

const fieldData: Array<{
    label: string;
    value: Omit<FieldValidationType, FieldValidationType.none>;
}> = [
    {
        label: 'Address',
        value: FieldValidationType.address,
    },
    {
        label: 'Date',
        value: FieldValidationType.date,
    },
    {
        label: 'Dollar',
        value: FieldValidationType.dollars,
    },
    {
        label: 'Email',
        value: FieldValidationType.email,
    },
    {
        label: 'Other',
        value: FieldValidationType.other,
    },
    {
        label: 'Phone',
        value: FieldValidationType.usMobilePhone,
    },
    {
        label: 'Year',
        value: FieldValidationType.years,
    },
];

type Props = TextFieldProps & {
    onSelectHandler: React.Dispatch<{ fieldType: FieldValidationType }>;
    className?: string;
};

export default function SelectFieldType({ onSelectHandler, className, ...props }: Props) {
    const { classes, cx } = useStyles();

    const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        onSelectHandler({
            fieldType: +event.target.value as FieldValidationType,
        });
    };

    return (
        <TextField
            {...(props as TextFieldProps)}
            select
            id={props.id || 'select_field_type'}
            label={props.label || 'Field Type'}
            name={props.name || 'fieldType'}
            onChange={handleSelect}
            className={cx(classes.textField, className && className)}
        >
            {fieldData.map(itm => (
                <MenuItem key={itm.label} value={itm.value as number}>
                    {itm.label}
                </MenuItem>
            ))}
        </TextField>
    );
}
